<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

  <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:96%;" ngStyle.lt-lg="width:100%;">
    <mat-card-title>
      <div fxLayout="row">

        <div fxFlex="grow" class="pageTitle" style="font-size: 22px;" fxLayoutAlign="start center center">Πεδία Βιογραφικών</div>

        <div fxLayoutGap="5px" fxLayoutAlign="end center center">
          <button mat-raised-button
                  style="color:white; background-color: #00bfa5; font-family: 'Century Gothic', sans-serif"
                  matTooltip="Δημιουργία νέας δήλωσης" (click)="createNewResumeField()">
            Δημιουργία νέου πεδίου
          </button>
        </div>
      </div>

    </mat-card-title>
    <mat-card-content fxLayout="column">

      <div fxLayout="row wrap" style="margin-top: 50px;">
        <div *ngFor="let field of questions" class="field-card mat-elevation-z3">
          <div fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="row">
              <label fxFlex="70">Τίτλος πεδίου Ελληνικά</label>
              <label>{{field.titleEL ? field.titleEL : '-'}}</label>
            </div>


            <div fxLayout="row">
              <label fxFlex="70">Τίτλος πεδίου Αγγλικά</label>
              <label>{{field.titleEN ? field.titleEN : '-'}}</label>
            </div>

            <div fxLayout="row">
              <label fxFlex="70">Τύπος πεδίου</label>
              <label>{{field.fieldType}}</label>
            </div>

          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
